// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
=============== 
Sidebar
===============
*/

.sidebar-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem 1.5rem;
}

.close-btn {
    font-size: 1.75rem;
    background: transparent;
    border-color: transparent;
    color: var(--clr-primary-5);
    transition: var(--transition);
    cursor: pointer;
    color: var(--clr-red-dark);
    margin-top: 0.2rem;
}

.close-btn:hover {
    color: var(--clr-red-light);
}

.logo {
    justify-self: center;
    height: 40px;
}

.links a {
    display: flex;
    align-items: center;
    font-size: 1.25rem;
    text-transform: capitalize;
    padding: 1rem 1.5rem;
    color: var(--clr-grey-3);
    transition: var(--transition);
    letter-spacing: var(--spacing);
}

.links a:hover {
    background: var(--clr-grey-10);
    color: var(--clr-grey-2);
}

.links a svg {
    font-size: 1.5rem;
    color: var(--clr-grey-5);
    margin-right: 1rem;
    transition: var(--transition);
}

.links a:hover svg {
    color: var(--clr-grey-4);
}

.social-icons {
    justify-self: center;
    display: flex;
    padding-bottom: 2rem;
}

.social-icons a {
    font-size: 1.5rem;
    margin: 0 0.5rem;
    color: var(--clr-primary-5);
    transition: var(--transition);
}

.social-icons a:hover {
    color: var(--clr-primary-1);
}

.sidebar {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: var(--clr-white);
    display: grid;
    grid-template-rows: auto 1fr auto;
    row-gap: 1rem;
    box-shadow: var(--clr-red-dark);
    transition: var(--transition);
    transform: translate(-100%);
}

.show-sidebar {
    transform: translate(0);
}

@media screen and (min-width: 676px) {
    .sidebar {
        width: 400px;
    }
}`, "",{"version":3,"sources":["webpack://./src/sidebar/sidebar.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,2BAA2B;IAC3B,6BAA6B;IAC7B,eAAe;IACf,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,0BAA0B;IAC1B,oBAAoB;IACpB,wBAAwB;IACxB,6BAA6B;IAC7B,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,iCAAiC;IACjC,aAAa;IACb,+BAA+B;IAC/B,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,YAAY;IAChB;AACJ","sourcesContent":["/*\r\n=============== \r\nSidebar\r\n===============\r\n*/\r\n\r\n.sidebar-header {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    padding: 1rem 1.5rem;\r\n}\r\n\r\n.close-btn {\r\n    font-size: 1.75rem;\r\n    background: transparent;\r\n    border-color: transparent;\r\n    color: var(--clr-primary-5);\r\n    transition: var(--transition);\r\n    cursor: pointer;\r\n    color: var(--clr-red-dark);\r\n    margin-top: 0.2rem;\r\n}\r\n\r\n.close-btn:hover {\r\n    color: var(--clr-red-light);\r\n}\r\n\r\n.logo {\r\n    justify-self: center;\r\n    height: 40px;\r\n}\r\n\r\n.links a {\r\n    display: flex;\r\n    align-items: center;\r\n    font-size: 1.25rem;\r\n    text-transform: capitalize;\r\n    padding: 1rem 1.5rem;\r\n    color: var(--clr-grey-3);\r\n    transition: var(--transition);\r\n    letter-spacing: var(--spacing);\r\n}\r\n\r\n.links a:hover {\r\n    background: var(--clr-grey-10);\r\n    color: var(--clr-grey-2);\r\n}\r\n\r\n.links a svg {\r\n    font-size: 1.5rem;\r\n    color: var(--clr-grey-5);\r\n    margin-right: 1rem;\r\n    transition: var(--transition);\r\n}\r\n\r\n.links a:hover svg {\r\n    color: var(--clr-grey-4);\r\n}\r\n\r\n.social-icons {\r\n    justify-self: center;\r\n    display: flex;\r\n    padding-bottom: 2rem;\r\n}\r\n\r\n.social-icons a {\r\n    font-size: 1.5rem;\r\n    margin: 0 0.5rem;\r\n    color: var(--clr-primary-5);\r\n    transition: var(--transition);\r\n}\r\n\r\n.social-icons a:hover {\r\n    color: var(--clr-primary-1);\r\n}\r\n\r\n.sidebar {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: var(--clr-white);\r\n    display: grid;\r\n    grid-template-rows: auto 1fr auto;\r\n    row-gap: 1rem;\r\n    box-shadow: var(--clr-red-dark);\r\n    transition: var(--transition);\r\n    transform: translate(-100%);\r\n}\r\n\r\n.show-sidebar {\r\n    transform: translate(0);\r\n}\r\n\r\n@media screen and (min-width: 676px) {\r\n    .sidebar {\r\n        width: 400px;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
